// yes_no as a question card: the question (and any helper text) on the
// left, No/Yes pill buttons on the right, the chosen pill dark. Discrete
// input — saves on change.

import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import ChoicePill from "components/ChoicePill";

import { FieldError } from "./chrome";
import { V2FieldProps } from "./types";

export default function YesNoField({ field, onCommit }: V2FieldProps) {
  const { control, trigger } = useFormContext();

  return (
    <Controller
      control={control}
      name={field.ref}
      rules={{
        validate: (value) =>
          !field.required || value !== undefined || "Please choose one",
      }}
      render={({ field: rhf, fieldState: { error } }) => {
        const choose = (answer: boolean) => {
          rhf.onChange(answer);
          void trigger(field.ref);
          onCommit();
        };
        return (
          <div>
            <div className="rounded-xl border border-oat-200 bg-white p-5 sm:flex sm:items-center sm:justify-between sm:gap-6">
              <div>
                <p className="font-medium text-soil">{field.title}</p>
                {field.description && (
                  <p className="mt-1 text-sm text-oat-700">
                    {field.description}
                  </p>
                )}
              </div>
              <div
                className="mt-4 flex shrink-0 gap-2 sm:mt-0"
                role="group"
                aria-label={field.title}
              >
                <ChoicePill
                  selected={rhf.value === false}
                  onSelect={() => choose(false)}
                >
                  No
                </ChoicePill>
                <ChoicePill
                  selected={rhf.value === true}
                  onSelect={() => choose(true)}
                >
                  Yes
                </ChoicePill>
              </div>
            </div>
            <FieldError message={error?.message} />
          </div>
        );
      }}
    />
  );
}
